"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getI18nInstance = getI18nInstance;

var _i18next = _interopRequireDefault(require("i18next"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var en = require('./locales/en-US/react-fulfillers.json');

var de = require('./locales/de-DE/react-fulfillers.json');

var fr = require('./locales/fr-FR/react-fulfillers.json');

var it = require('./locales/it-IT/react-fulfillers.json');

var nl = require('./locales/nl-NL/react-fulfillers.json');

var ja = require('./locales/ja-JP/react-fulfillers.json');

var zh = require('./locales/zh-CN/react-fulfillers.json');

var i18n_instance = null;

function getI18nInstance() {
  if (!i18n_instance) {
    i18n_instance = _i18next.default.createInstance();
    i18n_instance.init({
      fallbackLng: 'en',
      resources: {
        en: {
          translations: en
        },
        eng: {
          translations: en
        },
        de: {
          translations: de
        },
        deu: {
          translations: de
        },
        fr: {
          translations: fr
        },
        fra: {
          translations: fr
        },
        it: {
          translations: it
        },
        ita: {
          translations: it
        },
        nl: {
          translations: nl
        },
        nld: {
          translations: nl
        },
        ja: {
          translations: ja
        },
        jpn: {
          translations: ja
        },
        zh: {
          translations: zh
        },
        chi: {
          translations: zh
        },
        zho: {
          translations: zh
        }
      },
      ns: ['translations'],
      defaultNS: 'translations',
      debug: false,
      interpolation: {
        escapeValue: false // not needed for react!!

      },
      react: {
        wait: true
      }
    });
  }

  return i18n_instance;
}